export class InsertionCombination{
    // private _insertionCombination : number[] = new Array();
    // public get insertionCombination(){ return this._insertionCombination; }
    // public set insertionCombination(comb : number[]){ this._insertionCombination = comb; }

    private _insertionCombination = { surface : new Array(), reverse : new Array() };
    public get insertionCombination(){
        if(this._isReverse){ return this._insertionCombination.reverse; }
        else{ return this._insertionCombination.surface; }
    }
    public set insertionCombination(comb : number[]){
        if(this._isReverse){ this._insertionCombination.reverse = comb; }
        else{ this._insertionCombination.surface = comb; }
    }

    private _isReverse = false;
    public set isReverse(_isReverse : boolean){ this._isReverse = _isReverse; }
}